import parseJWT from 'utils/parseToken'
import {post} from 'utils/axios/index'
import {toast} from 'react-toastify'
import IAuth, {
 IOTPForm,
 IPublicAuthToken,
 IVerifyOTP,
} from 'models/Auth'
import ApiResponse, {
 DefaultApiResponse,
} from 'models/ApiResponse'
import {AxiosError} from 'axios'
import {handleRejectedErrorMsg} from 'utils/helpers/handleError'

const getOTP = async (payLoad: IOTPForm) => {
 try {
  return await (
   await post
  )<ApiResponse<IPublicAuthToken>>('/auth/v1/getOTP', {
   ...payLoad,
  }).then(async (res: DefaultApiResponse) => {
   // publish user to subscribers and store in local storage to stay logged in between page refreshes
   if (res.data?.user_id) {
    localStorage.setItem('userId', res.data?.user_id)
    return res.data?.user_id
   } else {
    toast.error(res.error.message)
    return null
   }
  })
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return null
 }
}

const login = async (payLoad: IVerifyOTP) => {
 try {
  return await (
   await post
  )<ApiResponse<IPublicAuthToken>>(
   '/platform/auth/v1/verifyOTP?app_code=dehaat_business&lang=en',
   {
    ...payLoad,
   }
  ).then(async (user: ApiResponse<IPublicAuthToken>) => {
   // publish user to subscribers and store in local storage to stay logged in between page refreshes
   if (user?.data && Object.keys(user?.data).length >= 0) {
    const results: IPublicAuthToken = user.data
    if (results.access_token) {
     const res = parseJWT(results.access_token)
     localStorage.setItem(
      'user',
      JSON.stringify({...results, ...res})
     )
    }
    return user.data
   } else {
    toast.error(user?.error?.error.message)
    return null
   }
  })
 } catch (err: unknown) {
  const e = err as AxiosError
  toast.error(e?.message ?? e)
  return null
 }
}

function logout() {
 localStorage.removeItem('user')
 // window.location.href = '/auth'
}

function updateUserData(data: IAuth) {
 // remove user from local storage, publish null to user subscribers and redirect to login page
 localStorage.setItem('user', JSON.stringify(data))
}

export const userService = {
 logout,
 login,
 updateUserData,
 getOTP,
}
